import {
  Box,
  Button,
  TextField,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ToastContainer, toast } from "react-toastify";
import Checkbox from "@mui/material/Checkbox";
import "react-toastify/dist/ReactToastify.css";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Autocomplete from "@mui/material/Autocomplete";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../../CONTEXT/AuthProvider";

const AddUser = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;

  const [subscribersList, setSubscribersList] = useState([]);

  const createdDate = new Date();
  const formattedDate = createdDate.toISOString();

  const [isDisputeManagement, setDisputeManagement] = useState(0);
  const [isNameLookup, setIsNameLookup] = useState(0);
  const [isPressureLetter, setIsPressureLetter] = useState(0);

  const handleChangeCheckBox = (event) => {
    const { name, checked } = event.target;
    switch (name) {
      case "isDisputeManagement":
        setDisputeManagement(checked ? 1 : 0);
        break;
      case "isNameLookup":
        setIsNameLookup(checked ? 1 : 0);
        break;
      case "isPressureLetter":
        setIsPressureLetter(checked ? 1 : 0);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    axios
      .get("/api/subscribers", {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((response) => {
        setSubscribersList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [accessToken]);

  const handleFormSubmit = async (values) => {
    if (values.password !== values.confirmPassword) {
      toast.error("Password and confirm password should match!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      const firstname = values.firstName;
      const middlename = values.middleName;
      const lastname = values.lastName;
      const username = values.username;
      const email = values.email;
      const staff = values.staff;
      const role = values.role;
      const subscriberName = values.subscriber;
      const password = values.password;
      const designation = values.designation;
      const digitalLendor = values.digitalLendor;
      const phoneNumber = values.phoneNumber;
      try {
        const data = {
          firstname,
          middlename,
          lastname,
          username,
          email,
          staff,
          role,
          subscriberName,
          password,
          addedBy: auth.username,
          addedDate: formattedDate,
          designation,
          digitalLendor,
          phoneNumber,
          isDisputeManagement,
          isNameLookup,
          isPressureLetter,
        };

        await axios.post("/api/register-user", data, {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        });
        toast.success("User added successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header title="ADD USER" subtitle="Create a new user in the system" />

          <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={checkoutSchema}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="First Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.firstName}
                    name="firstName"
                    error={!!touched.firstName && !!errors.firstName}
                    helperText={touched.firstName && errors.firstName}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Middle Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.middleName}
                    name="middleName"
                    error={!!touched.middleName && !!errors.middleName}
                    helperText={touched.middleName && errors.middleName}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Last Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.lastName}
                    name="lastName"
                    error={!!touched.lastName && !!errors.lastName}
                    helperText={touched.lastName && errors.lastName}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Username"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.username}
                    name="username"
                    error={!!touched.username && !!errors.username}
                    helperText={touched.username && errors.username}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="email"
                    label="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    name="email"
                    error={!!touched.email && !!errors.email}
                    helperText={touched.email && errors.email}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <FormControl
                    fullWidth
                    variant="filled"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <InputLabel id="staff-label">Staff</InputLabel>
                    <Select
                      labelId="staff-label"
                      name="staff"
                      value={values.staff}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={!!touched.staff && !!errors.staff}
                      helperText={touched.staff && errors.staff}
                    >
                      <MenuItem value=""></MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>
                  {values.staff === "Yes" && (
                    <FormControl
                      fullWidth
                      variant="filled"
                      sx={{ gridColumn: "span 2" }}
                    >
                      <InputLabel id="role-label">Role</InputLabel>
                      <Select
                        labelId="role-label"
                        name="role"
                        value={values.role}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!touched.role && !!errors.role}
                        helperText={touched.role && errors.role}
                      >
                        <MenuItem value=""></MenuItem>
                        <MenuItem value="admin">Admin</MenuItem>
                        <MenuItem value="management">Management</MenuItem>
                        <MenuItem value="project manager">Project Manager</MenuItem>
                        <MenuItem value="consumer">Consumer</MenuItem>
                        <MenuItem value="compliance">Compliance</MenuItem>
                        <MenuItem value="sales">Sales</MenuItem>
                      </Select>
                    </FormControl>
                  )}

                  <FormControl
                    fullWidth
                    variant="filled"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <Autocomplete
                      id="subscriber-select"
                      options={subscribersList}
                      getOptionLabel={(option) => option.subscriber_name}
                      value={
                        subscribersList.find(
                          (sub) => sub.subscriber_name === values.subscriber
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        handleChange({
                          target: {
                            name: "subscriber",
                            value: newValue?.subscriber_name || "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="subscriber"
                          label="Subscriber"
                          error={!!touched.subscriber && !!errors.subscriber}
                          helperText={touched.subscriber && errors.subscriber}
                        />
                      )}
                    />
                  </FormControl>
                  {values.staff === "No" && (
                    <>
                      <FormControl
                        fullWidth
                        variant="filled"
                        sx={{ gridColumn: "span 2" }}
                      >
                        <Autocomplete
                          id="subscriber-select"
                          options={subscribersList}
                          getOptionLabel={(option) => option.subscriber_name}
                          value={
                            subscribersList.find(
                              (sub) =>
                                sub.subscriber_name === values.digitalLendor
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            handleChange({
                              target: {
                                name: "digitalLendor",
                                value: newValue?.subscriber_name || "",
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="digitalLendor"
                              label="Digital Lendor"
                              error={
                                !!touched.digitalLendor &&
                                !!errors.digitalLendor
                              }
                              helperText={
                                touched.digitalLendor && errors.digitalLendor
                              }
                            />
                          )}
                        />
                      </FormControl>

                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Phone Number"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.phoneNumber}
                        name="phoneNumber"
                        error={!!touched.phoneNumber && !!errors.phoneNumber}
                        helperText={touched.phoneNumber && errors.phoneNumber}
                        sx={{ gridColumn: "span 2" }}
                      />
                    </>
                  )}

                  {values.staff === "No" && (
                    <FormControl
                      fullWidth
                      variant="filled"
                      sx={{ gridColumn: "span 2" }}
                    >
                      <InputLabel id="designation-label">
                        Designation
                      </InputLabel>
                      <Select
                        labelId="designation-label"
                        name="designation"
                        value={values.designation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!touched.designation && !!errors.designation}
                        helperText={touched.designation && errors.designation}
                      >
                        <MenuItem value=""></MenuItem>
                        <MenuItem value="user">Normal User</MenuItem>
                        <MenuItem value="CEO">CEO</MenuItem>
                      </Select>
                    </FormControl>
                  )}

                  <TextField
                    fullWidth
                    variant="filled"
                    type="password"
                    label="Password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    name="password"
                    error={!!touched.password && !!errors.password}
                    helperText={touched.password && errors.password}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="password"
                    label="Confirm Password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.confirmPassword}
                    name="confirmPassword"
                    error={
                      !!touched.confirmPassword && !!errors.confirmPassword
                    }
                    helperText={
                      touched.confirmPassword && errors.confirmPassword
                    }
                    sx={{ gridColumn: "span 2" }}
                  />
                  <FormControl component="fieldset" variant="standard">
                    <FormLabel component="legend">Access</FormLabel>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isDisputeManagement}
                            onChange={handleChangeCheckBox}
                            name="isDisputeManagement"
                          />
                        }
                        label="Disputes Management"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isNameLookup}
                            onChange={handleChangeCheckBox}
                            name="isNameLookup"
                          />
                        }
                        label="Name Lookup"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isPressureLetter}
                            onChange={handleChangeCheckBox}
                            name="isPressureLetter"
                          />
                        }
                        label="Pressure Letters"
                      />
                    </FormGroup>
                  </FormControl>
                </Box>
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button type="submit" color="success" variant="contained">
                    Create New User
                  </Button>
                </Box>
                <ToastContainer />
              </form>
            )}
          </Formik>
        </Box>
      </main>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  firstName: yup.string().required("required"),
  lastName: yup.string().required("required"),
  email: yup.string().required("required"),
  username: yup.string().required("required"),
  staff: yup.string().required("required"),
  password: yup.string().required("required"),
  confirmPassword: yup.string().required("required"),
});
const initialValues = {
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  username: "",
  staff: "",
  role: "",
  subscriber: "",
  digitalLendor: "",
  phoneNumber: "",
  password: "",
  confirmPassword: "",
  designation: "",
};

export default AddUser;
